var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageContent)?_c('main',{staticClass:"p-blank"},[_c('section',{staticClass:"simple-hero"},[_c('Cta',{attrs:{"type":'title',"sentences":( _obj = {}, _obj[_vm.pageContent.title] = '', _obj )}}),_c('div',{staticClass:"simple-hero__subtitle",domProps:{"innerHTML":_vm._s(_vm.pageContent.fields.hero_subtitle)}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }